import React from 'react';
import App from './components/App/App';
import { createRoot } from 'react-dom/client';

const renderApp = () => {
  const domNode =
    document.getElementById('root') || document.createElement('div');
  domNode.replaceChildren();
  createRoot(domNode).render(<App />);
};

renderApp(); // init
window.addEventListener('rerenderAppTemplates', renderApp); // for rerender of the dom over docs
